import './Led.css';
import React from "react";
import { Link } from "react-router-dom";
import Led1 from '../../assets/Productos/Led/Led1.png';
import Led2 from '../../assets/Productos/Led/Led2.png';
import Led3 from '../../assets/Productos/Led/Led3.png';
import Led4 from '../../assets/Productos/Led/Led4.png';
import Led5 from '../../assets/Productos/Led/Led5.png';
import Led6 from '../../assets/Productos/Led/Led6.png';
import Led7 from '../../assets/Productos/Led/Led7.png';
import Led8 from '../../assets/Productos/Led/Led8.png';
import Led9 from '../../assets/Productos/Led/Led9.png';
import Led10 from '../../assets/Productos/Led/Led10.png';
import Led11 from '../../assets/Productos/Led/Led11.png';
import Led12 from '../../assets/Productos/Led/Led12.png';


const images = [
    { src: Led1, text: "MF281 Grasa termoconductora de silicona", id: 23},
    { src: Led2, text: "MF282 Sellador termoconductor de silicona", id: 24},
    { src: Led3, text: "MF280 Sellador electrónico de silicona", id: 25},
    { src: Led4, text: "MF210 Adhesivo termoconductor", id: 26},
    { src: Led5, text: "MF211 Sellador térmico", id: 27},
    { src: Led6, text: "MF4150 Silicona plástica", id: 28},
    { src: Led7, text: "MF4160 Silicona plástica", id: 29},
    { src: Led8, text: "MF5360 Silicona adhesiva para LED", id: 30},
    { src: Led9, text: "MF5380 Silicona encapsulante para LED", id: 31},
    { src: Led10, text: "MF1308 Adhesivo epoxy de curado rápido", id: 32},
    { src: Led11, text: "MF1309 Adhesivo epoxy de curado rápido", id: 33},
    { src: Led12, text: "MF1560 SMT parchador plástico", id: 34},
];

function Led() {
    return (
        <div className="arquitectura-container">
            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <Link to={`/productos/${item.id}`}>
                            <img src={item.src} alt={item.text} />
                        </Link>
                        <p>{item.text}</p> {/* Nombre del producto sin enlace */}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Led;
